import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import { Button } from 'components/Button/Button';
import { radius } from 'themes/radius';

interface EmptyWidgetStateProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  description: string;
  title?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(4, 2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  ...theme.typography.subheadline,
  marginTop: theme.spacing(3),
  paddingInline: theme.spacing(3),
  fontWeight: 'normal',
  borderRadius: radius.pill,
  backgroundColor: theme.palette.grey['400'],
  color: theme.palette.brandShade1.main,
}));

const Description = styled(Typography)({
  maxWidth: '209px',
});

const IconWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  width: '90px',
  height: '60px',
}));
// NOTE: This can be reused for Medication and step count
export const EmptyWidgetState = ({
  icon: Icon,
  description,
  title,
  buttonText,
  onButtonClick,
}: EmptyWidgetStateProps) => (
  <Container>
    <IconWrapper aria-hidden="true">
      <Icon />
    </IconWrapper>
    {title ? (
      <Typography color="grey.800" fontWeight={500} variant="callout">
        {title}
      </Typography>
    ) : (
      <Box aria-hidden sx={{ height: (theme) => theme.spacing(1) }} />
    )}
    <Description variant="callout" color="grey.800">
      {description}
    </Description>
    {buttonText && onButtonClick && (
      <StyledButton size="large" variant="contained" onClick={onButtonClick}>
        {buttonText}
      </StyledButton>
    )}
  </Container>
);
